// Duplicate Product Translations
export const duplicateTranslations = {
  en: {
    "Duplicate Product": "Duplicate Product",
    "Customize duplicate settings": "Customize duplicate settings",
    "Original Product": "Original Product",
    "Customize New Product": "Customize New Product",
    "Product Title": "Product Title",
    "Enter new product title": "Enter new product title",
    "Enter new SKU": "Enter new SKU",
    "Enter new slug": "Enter new slug",
    "Enter new price": "Enter new price",
    "Stock Quantity": "Stock Quantity",
    "Enter stock quantity": "Enter stock quantity",
    "Active Product": "Active Product",
    "Track Stock": "Track Stock",
    "Copy Product Variants": "Copy Product Variants",
    "The product will be duplicated with default settings:": "The product will be duplicated with default settings:",
    "Title will be:": "Title will be:",
    "SKU will be:": "SKU will be:",
    "All variants and translations will be copied": "All variants and translations will be copied",
    "All other settings will remain the same": "All other settings will remain the same",
    "Cancel": "Cancel",
    "Duplicate Product": "Duplicate Product"
  },
  ar: {
    "Duplicate Product": "نسخ المنتج",
    "Customize duplicate settings": "تخصيص إعدادات النسخ",
    "Original Product": "المنتج الأصلي",
    "Customize New Product": "تخصيص المنتج الجديد",
    "Product Title": "عنوان المنتج",
    "Enter new product title": "أدخل عنوان المنتج الجديد",
    "Enter new SKU": "أدخل SKU جديد",
    "Enter new slug": "أدخل slug جديد",
    "Enter new price": "أدخل السعر الجديد",
    "Stock Quantity": "كمية المخزون",
    "Enter stock quantity": "أدخل كمية المخزون",
    "Active Product": "منتج نشط",
    "Track Stock": "تتبع المخزون",
    "Copy Product Variants": "نسخ متغيرات المنتج",
    "The product will be duplicated with default settings:": "سيتم نسخ المنتج بالإعدادات الافتراضية:",
    "Title will be:": "العنوان سيكون:",
    "SKU will be:": "SKU سيكون:",
    "All variants and translations will be copied": "سيتم نسخ جميع المتغيرات والترجمات",
    "All other settings will remain the same": "جميع الإعدادات الأخرى ستبقى كما هي",
    "Cancel": "إلغاء",
    "Duplicate Product": "نسخ المنتج"
  }
};

// Function to get translation
export const getDuplicateTranslation = (key, language = 'en') => {
  return duplicateTranslations[language]?.[key] || duplicateTranslations['en'][key] || key;
};
